
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/team/[id]",
      function () {
        return require("private-next-pages/team/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/team/[id]"])
      });
    }
  